module.exports = __webpack_public_path__ + "static/img/19-0919_1.7a48379.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/19-0919_1.jpg
// module id = hDAp
// module chunks = 0